import { WhitelistAction } from '../global';

export const RESET_PAYMENT_TOKEN_STATE = 'RESET_TOKEN_STATE';
export const TRAVELLER_PAYMENT_DETAILS = 'TRAVELLER_PAYMENT_DETAILS';
export const INITIATE_TOKEN = 'INITIATE_TOKEN';
export const RESET_PAYMENT_STORE = 'RESET_PAYMENT_STORE';
export const SET_PAYMENT_TOKEN = 'SET_PAYMENT_TOKEN';

export enum PAYMENT_METHOD {
  CASH = 'CASH',
  CREDIT_CARD = 'CREDIT_CARD',
  PAID_TO_AGENCY = 'PAID_TO_AGENCY'
}

export enum PAYMENT_TYPE {
  CARD = 'CARD',
  TOKEN = 'TOKEN'
}

export enum CC_NUMBER {
  AMEX = '3',
  VISA = '4',
  MASTER = '5'
}

export enum TOKENIZATION_STATE {
  NOT_STARTED = 'NOT_STARTED',
  INITIATED = 'INITIATED',
  COMPLETED = 'COMPLETED'
}

export interface TravellerPayment extends WhitelistAction {
  paymentMethod?: PAYMENT_METHOD;
  paymentAmount?: number;
  token?: string;
  ccType?: string;
  tokenError?: string[];
  cvvTokenErr?: string[];
  paxId: number;
  initiateToken?: boolean;
  paymentType?: boolean;
  [tokenNumber: string]: unknown;
  cvv?: string;
  expiryDate?: string;
}

export interface TravellerPaymentStore {
  [paxId: number]: TravellerPayment;
  policyTokenizationInitiated: TOKENIZATION_STATE;
  cardHolderName?: { [cardHolderName: string]: string };
}

export interface TravellerPaymentAction {
  type: string;
  payload?: TravellerPayment;
  cardHolderName?: { [cardHolderName: string]: string };
}
